itsoftApp.createModule("videoAuto", function () {
    const module = this;

    const videoInit = function (video) {
        video.play();
    }

    module.init = videoInit;
});